<template>
	<div class="loginBody">
        <!-- <login-nav></login-nav> -->
		<div class="login">
			<el-form :model="formData" ref="form" label-width="100px" :rules="rules" class="login-form">
			  <el-form-item label="手機號碼" required>
			  	<el-row :gutter="10">
				  	<el-col :span="10">
				  	  <el-form-item prop="area">
						    <el-select v-model="formData.area" placeholder="請選擇區域">
						      <el-option style="text-align:right;" v-for="item in phoneAddressArr" :label="item.aName+' +'+item.acode" :key="item.aName" :value="item.acode">
						      	{{item.aName}} +{{item.acode}}
						      </el-option>
						    </el-select>
					  	</el-form-item>
				  	</el-col>
				  	<el-col class="line" :span="1">-</el-col>
				    <el-col :span="10">
				      <el-form-item prop="mobile">
								<el-input v-model="formData.mobile" placeholder="請輸入手機號碼"></el-input>
					  	</el-form-item>
						</el-col>
					</el-row>
			  </el-form-item>
			  <el-form-item label="驗證碼" prop="code">
			  	<el-row :gutter="10">
				  	<el-col :span="12">
				  		<el-input v-model="formData.code" placeholder="請輸入手機驗證碼"></el-input>
				  	</el-col>
				  	<el-col :span="11">
				    	<el-button type="primary" :disabled='codeBool' @click="getCode" round :class='[codeBool ? "login-codebtn-disable" : "code-btn"]'>{{codeText}}</el-button>
				  	</el-col>
				  </el-row>
			  </el-form-item>
			  <el-form-item>
			    <el-button type="primary" @click="submitForm('form')" class="login-btn">登錄</el-button>
			  </el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
    import LoginNav from '../components/loginNav.vue';
	export default {
		components:{LoginNav},
		name: 'login',
		data () {
			let checkPhone = (rule, value ,callback) => {
		        if (!value) {
		          return callback(new Error('請填寫手機號碼'))
		        }
		        callback();
	    	};
			let checkCode = (rule, value ,callback) => {
        		if (!value) {
          			return callback(new Error('請填寫驗證碼'))
        		}
		        callback();
    		};
			let checkPhoneAddress = (rule, value ,callback) => {
       			if (!value) {
        			return callback(new Error('請填寫驗證碼'))
        		}
		        callback();
    		};
    		return {
    			formData: {
    				area:'',
		        	mobile: '',
		         	code:'',
		         	meetingName:'ida',
		        },
		        rules:{
		        	area:[
		        	 {required: true,validator: checkPhoneAddress,trigger:'change'}
		        	],
		        	mobile:[
		        	 {required: true,validator: checkPhone,trigger:'blur'}
		        	],
		        	code:[
		        	 {required: true,validator: checkCode,trigger:'blur'}
		        	],
		        },

		        // phoneAddressArr:[{"acode": "60","aName": "马来西亚"}],
		        phoneAddressArr:[],

  				codeText:'獲取驗證碼',//验证码按钮文字
  				codeTime:60,//验证码发送时间
  				codeBool:false,//验证码是否可以点击
    		}
    	},
		created(){
			this.getAreas();
		},

		methods:{
			open2(msg) {
		        this.$message({
		          message: msg,
		          type: 'success'
		        });
		      },

		      open3(msg) {
		        this.$message({
		          message: msg,
		          type: 'warning'
		        });
		      },

		      open4(msg) {
		        this.$message.error(msg);
		      },

			getCode: async function(){
				console.log(this.formData);
				if(this.formData.area && this.formData.mobile){
					this.codeBool = true;
					const res = await this.$axios.post('/project/SnsController/sendVerificationCode.do',this.formData);
					console.log(res);
					if(res && res.data.status == 1){
	                    this.open2("發送成功！");
	                    const jishiNum = setInterval(() => {
	                        this.codeTime--;
	                        if(this.codeTime == 0){
	                            this.codeText = "重新獲取";
	                            this.codeBool = false;
	                            this.codeTime = 60;
	                            clearTimeout(jishiNum);
	                        }else{
	                            this.codeText = this.codeTime + "s後重發";
	                        }
	                    },1000);
	                }else{
	                    this.open4('僅限當年度有效會員');
	                    this.codeBool = false;
	                    this.codeText = "重新獲取";
	                }
	            }else{
	            	this.open3('手機信息填寫有誤')
	            }
			},
			getJson: async function(){
				console.log(this.formData);
				const res = await this.$axios.post('/project/SnsController/queryIda.do',this.formData);
				// console.log(JSON.stringify(res.data.data));
				console.log(res);
				if(res.data.status==1){
					localStorage.clear();
					localStorage.setItem('token',res.data.data);
					// localStorage.setItem('arr',JSON.stringify(res.data.data));
					this.open2('登錄成功');
		            this.$router.replace('/list_down');
					
				}else{
					this.open4('登錄失敗！'+res.data.msg);
				}
			},
			getAreas(){
				// this.$axios.get('download/static/callingcodes.json').then((res) =>{
				// 	console.log(res);
				// 	console.log(res.data);
				// 	this.phoneAddressArr = [...res.data];
				// })
				this.phoneAddressArr.push({acode: "86",aName: "中國大陸"},{acode: "852",aName: "香港"},{acode: "853",aName: "澳門"},{acode: "886",aName: "台灣"},{acode: "65",aName: "新加坡"},{acode: "60",aName: "馬來西亞"},{acode: "61",aName: "澳大利亞"},{acode: "62",aName: "印尼"},{	acode: "63",aName: "菲律賓"},{acode: "64",aName: "新西蘭"},{acode: "66",aName: "泰國"},{acode: "001",aName: "美國"},{acode: "001",aName: "加拿大"},{acode: "81",aName: "日本"},{acode: "82",aName: "韓國"},{acode: "84",aName: "越南"},{acode: "673",aName: "文萊"})
			},

			submitForm(formName) {

				console.log(this.$refs[formName]);
		        this.$refs[formName].validate((valid) => {
		        	// console.log('我是valid'+valid);
		          if (valid) {
		            // console.log("提交成功");
		            this.getJson();
		          } else {
		            // console.log('error submit!!');
		            return false;
		          }
		        });
		    },

		},
	}
</script>
<style scoped>
.loginBody{
  min-width:300px;
  max-width:1200px;
  width:90%;
  background:#fff;
  padding:0 0 60px 0;
  margin:25px auto 0;
}

.login{
	min-width:260px;
	max-width:500px;
	background:#fff;
	padding:80px 20px 20px;
	margin:0 auto;
}

.code-btn{
	background:#fff;
	color:#cfb284;
	border-color:#cfb284;
}
.login-btn{
	background:#cfb284;
	color:#fff;
	border-color:#cfb284;
}

</style>


// WEBPACK FOOTER //
// src/pages/login.vue